import rawLocaleConfig from './locales.json'

export const supportedLocales = rawLocaleConfig.locales
export const defaultLocale = rawLocaleConfig.defaultLocale
export const fallbackLocale = rawLocaleConfig.fallbackLocale
export const localeAliases = rawLocaleConfig.aliases

export type SupportedLocale = (typeof supportedLocales)[number]

export const isSupportedLocale = (locale?: string): locale is SupportedLocale => {
  if (!locale) return false

  return (
    supportedLocales.includes(locale as SupportedLocale) ||
    Object.prototype.hasOwnProperty.call(localeAliases, locale)
  )
}
